import React from 'react';

const WelcomeBanner = ({
  image,
  data,
}: {
  image: string;
  data: { title: string; description: string };
}) => {
  return (
    <div
      className="relative hidden lg:flex w-full max-w-[1800px] h-[180px] lg:h-[280px] bg-background-main overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${image})` }}
    >
      {/* Content container */}
      <div className="w-full flex px-4 lg:pl-[70px] items-center">
        {/* Text content */}
        <div className="max-w-lg">
          <h1 className="text-2xl lg:text-4xl font-bold text-white mb-2 lg:mb-4">
            {data.title}
          </h1>
          <p className="text-[14px] lg:text-[18px] text-white w-full lg:w-[474px]">
            {data.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
